import yellow from "@material-ui/core/colors/yellow";

export const black = "#1F2720";
export const newDarkBlue = "#2B3F4F";
export const newBlue = "#1B61B1";

// Didn't want to name it primaryColor :-S
export const colorForPrimaryThings = yellow[900];
